function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "testmonial-quote");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Main",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "testimonial/dennis",
  transform: "translate(-36.000000, -55.000000)",
  fill: "#222426",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(36.000000, 55.000000)"
}, React.createElement("path", {
  d: "M23.125,20.234375 L23.125,11.5625 L19.4140625,11.5625 L19.4140625,10.6640625 C19.4140625,8.5546875 19.6419271,6.85546875 20.0976562,5.56640625 C20.5533854,4.27734375 21.2369792,3.38541667 22.1484375,2.890625 L22.1484375,2.890625 L22.1484375,0 C19.5703125,0.651041667 17.6432292,2.12239583 16.3671875,4.4140625 C15.0911458,6.70572917 14.453125,9.81770833 14.453125,13.75 L14.453125,13.75 L14.453125,20.234375 L23.125,20.234375 Z M8.671875,20.234375 L8.671875,11.5625 L4.9609375,11.5625 L4.9609375,10.6640625 C4.9609375,8.5546875 5.18880208,6.85546875 5.64453125,5.56640625 C6.10026042,4.27734375 6.78385417,3.38541667 7.6953125,2.890625 L7.6953125,2.890625 L7.6953125,0 C5.1171875,0.651041667 3.19010417,2.12239583 1.9140625,4.4140625 C0.638020833,6.70572917 0,9.81770833 0,13.75 L0,13.75 L0,20.234375 L8.671875,20.234375 Z",
  id: "\u201C"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/quotes.fe8205fe.svg";
export { SvgComponent as ReactComponent };